import React from 'react'
import { View, TouchableOpacity } from 'react-native'
import PropTypes from 'prop-types'

import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components'

import { Images, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import styles from './Error.Styles'

const Error = ({
  error,
  onPress,
}) => {

  const theme = useTheme()
  return (
    <View style={styles.errorContainer}>
      <VFText
        i18nKey={error}
        style={styles.errorText(theme)}
      />
      <TouchableOpacity
        style={styles.tryAgainContainer}
        onPress={onPress}
      >
        <VFText
          i18nKey="acquisition_try_again"
          style={styles.tryAgainText}
        />
        <Icon
          name={Images.ic_RefreshRed}
          size={30}
          resizeMode="contain"
        />
      </TouchableOpacity>
    </View>
  )
}

Error.propTypes = {
  error: PropTypes.string,
  onPress: PropTypes.func,
}

export default Error
